/**
 * reGetuserInfo 無參數重抓時的查詢參數決策。
 *
 * 修正：ukey 登入的使用者重抓時，舊預設只送 {dvc, jkey} 會被後端當成
 * 匿名裝置查詢（rtn 100），setUser 不會執行且完全靜默——卡片入座數等
 * 依 user 的畫面因此不更新。有 ukey 一律優先用 ukey；沒有才走原本的
 * dvc/jkey（裝置登入流程維持不變）。呼叫端有明確給參數時原樣使用。
 */
export function resolveUserInfoQuery(request, { ukey, dvc, jkey } = {}) {
    if (request) return request;
    if (ukey) return { ukey };
    return { dvc, jkey };
}

/**
 * 開機（App 初始化）時 getUserInfo 的查詢決策。
 * 優先序：網址 ukey > LS ukey（僅 seat-only 站台；修正「重整後變未登入」，
 * legacy 站台維持 dvc 流程原樣）> dvc。jkey 一律附帶。
 * 注意副作用：seat-only 站台只要瀏覽器登入過，之後無參數進站都會自動登回
 * 該帳號（客戶 2026-11-03 知悉並同意）。
 */
export function resolveBootUserQuery({ urlUkey, jkey, lsUkey, dvc, seatOnly } = {}) {
    const req = {};
    if (urlUkey) {
        req.ukey = urlUkey;
    } else if (seatOnly && lsUkey) {
        req.ukey = lsUkey;
    } else if (dvc) {
        req.dvc = dvc;
    }
    if (jkey) req.jkey = jkey;
    return req;
}
